import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useCheckDocumentPermission } from 'pages/documents/utilities'
import { useCategories } from 'pages/documents/utilities'
import FileSize from 'components/file-size'
import {
    Aside,
    Kicker, CloseButton, Header,
    FileNameIcon, Meta, FakeLabel, Category
} from './s'
import { H4 } from 'components/typography/heading'
import Fields from './fields'
import Signing from './signing'
import Actions from './actions'

const PreviewDocumentDetailsEdit = ({
    dokument: originalDokument = {},
    mode = 'view',
    file,
    setReviewingDocumentSigningStatus,
    previewAnother,
    removeAction,
    updatedAt,
    dismiss,
    salt,
    ...props
}) => {
    const [dokument, setDokument] = useState(originalDokument)

    let {
        name,
        extension,
        category,
        type,
        createdBy,
        createdAt
    } = dokument

    const { editable } = useCheckDocumentPermission()(dokument)

    const [editing, setEditing] = useState((editable && mode === 'edit') ? 'auto' : null)

    const {
        categories,
        getCategoryLabel
    } = useCategories()

    useEffect(() => {
        if(!!originalDokument?.id && !!updatedAt) {
            setDokument(originalDokument)
        }
    }, [!!originalDokument?.id, updatedAt])

    category = category ?? 'none'

    if(type === 'smart') {
        extension = 'smart'
    }

    return (
        <Aside>
            <Kicker>
                <H4 className="compact">
                    <FormattedMessage
                        id="noun_details"
                        defaultMessage="Details" />
                </H4>
                <CloseButton onClick={dismiss} />
            </Kicker>
            {!editing && (
                <Header>
                    <FileNameIcon
                        name={name}
                        extension={extension}
                        ellipsify={false} />
                    <FakeLabel className="compact indent">
                        {!!file && (
                            <span>
                                <FileSize bytes={file.size} />
                            </span>
                        )}
                        <Category>
                            {getCategoryLabel(category)}
                        </Category>
                    </FakeLabel>
                </Header>
            )}
            <Fields
                dokument={dokument}
                setDokument={setDokument}
                editing={editing}
                setEditing={setEditing}
                categories={categories}
                previewAnother={previewAnother}
                salt={salt}
                key={`${salt}:${editing ? 'editing' : 'viewing'}`} />
            {!editing && (
                <>
                    <Signing
                        {...props}
                        dokument={dokument}
                        setReviewingDocumentSigningStatus={setReviewingDocumentSigningStatus} />
                    <Actions
                        {...props}
                        dokument={dokument}
                        setEditing={setEditing}
                        removeAction={removeAction}
                        dismiss={dismiss}
                        salt={salt} />
                    <Meta
                        type="created"
                        by={createdBy}
                        at={createdAt}
                        time="fixed" />
                </>
            )}
        </Aside>
    )
}

export default PreviewDocumentDetailsEdit